import axios from 'axios';
const DEMO_API = process.env.REACT_APP_DEMO_API;

const baseURL = '/';

const api = axios.create({
  baseURL,
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: 0,
  },
});

export default api;

// items

export const getLinkToken = () =>
  api.post(`${DEMO_API}/api/pattern_create_link_token`);

export const exchangeToken = async (publicToken: string, institution: any) => {
  try {
    const { data } = await api.post(
      `${DEMO_API}/api/pattern_set_access_token`,
      {
        public_token: publicToken,
        institutionId: institution.institution_id,
      }
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

// institutions
export const getInstitutionById = (instId: string) =>
  api.get(`${DEMO_API}/api/pattern_institution/${instId}`);
